
export default (state = {}, action) => {
    switch (action.type) {
        case 'set':
            state = JSON.parse(JSON.stringify(state))
            _.set(state, action.key, action.payload)
            return state;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/config.js